export const images = {
  cart_black: '/assets/images/ic-cart-black-32.png',
  cart_white: '/assets/images/ic-cart-white-32.png',
  coin_black: '/assets/images/ic-coin-black.png',
  coin_white: '/assets/images/ic-coin-white.png',
  user_black: '/assets/images/ic-user-black.png',
  user_white: '/assets/images/ic-user-white.png',
  menu_black: '/assets/images/ic-menu-b.png',
  menu_white: '/assets/images/ic-menu-w.png',
  close: '/assets/images/ic-close.png',
  unplay: '/assets/images/ic-unplay.png',
  play: '/assets/images/ic-play.png',
  youtube: '/assets/images/ic-sns-youtube.png',
  facebook: '/assets/images/ic-sns-facebook.png',
  instagram: '/assets/images/ic-sns-instagram.png',
  unplay_video: '/assets/images/ic-unplay-video.png',
  play_video: '/assets/images/ic-play-video.png',
  sound_on: '/assets/images/ic-sound-on.png',
  sound_off: '/assets/images/ic-sound-off.png',
  expand: '/assets/images/ic-expand.png',
  kakao: '/assets/images/ic-sns-kakao.png',
  naver: '/assets/images/ic-sns-naver.png',
  unselect: '/assets/images/ic-unselect.png',
  select: '/assets/images/ic-select.png',
  dropdown_black: '/assets/images/ic-dropdown-black.png',
  dropdown_blue: '/assets/images/ic-dropdown-blue.png',
  search_24: '/assets/images/ic-search-24.png',
  minus: '/assets/images/ic-minus.png',
  plus: '/assets/images/ic-plus.png',
  right_arrow: '/assets/images/ic-go-right-24.png',
  download_gray: '/assets/images/ic-download-g.png',
  heart_gray: '/assets/images/ic-heart-g.png',
  cart_gray: '/assets/images/ic-cart-g.png',
  download_black: '/assets/images/ic-download-b.png',
  heart_black: '/assets/images/ic-heart-b.png',
  cart_black_22: '/assets/images/ic-cart-b.png',
  delete: '/assets/images/ic-delete.png',
  eye_disable: '/assets/images/ic-eye-disable.png',
  eye: '/assets/images/ic-eye.png',
  date: '/assets/images/ic-date.png',
  left_arrow_double_gray: '/assets/images/ic-gogo-left-18-g.png',
  left_arrow_18_gray: '/assets/images/ic-go-left-18-g.png',
  right_arrow_double_gray: '/assets/images/ic-gogo-right-18-g.png',
  right_arrow_18_gray: '/assets/images/ic-go-right-18-g.png',
  left_arrow_double_black: '/assets/images/ic-gogo-left-18-b.png',
  left_arrow_18_black: '/assets/images/ic-go-left-18-b.png',
  right_arrow_double_black: '/assets/images/ic-gogo-right-18-b.png',
  right_arrow_18_black: '/assets/images/ic-go-right-18-b.png',
  profile_placeholder: '/assets/images/profile-placeholder.jpeg',
  down_16: '/assets/images/ic-down-16.png',
  place: '/assets/images/ic-place.png',
  play_hover: '/assets/images/ic-play-hover.png',
  logo_small: '/assets/images/ic-logo-small.png',
  logo_big: '/assets/images/ic-logo-big.png',
  logo: '/assets/images/meleon_logo.png',
  logo_w: '/assets/images/logo-w.png',
  music1: '/assets/images/music1.png',
  music2: '/assets/images/music2.png',
  music3: '/assets/images/music3.png',
  music4: '/assets/images/music4.png',
  music5: '/assets/images/music5.png',
  music6: '/assets/images/music6.png',
  music7: '/assets/images/music7.png',
  music8: '/assets/images/music8.png',
  sea_img: '/assets/images/sea-start.png',
  splash_start: 'assets/images/splash-start.png',
  preview: {
    img1: '/assets/images/preview-img/img1@3x.png',
    img2: '/assets/images/preview-img/img2@3x.png',
    img3: '/assets/images/preview-img/img3@3x.png',
    img4: '/assets/images/preview-img/img4@3x.png',
    img5: '/assets/images/preview-img/img5@3x.png',
    img6: '/assets/images/preview-img/img6@3x.png',
    img7: '/assets/images/preview-img/img7@3x.png',
    img8: '/assets/images/preview-img/img8@3x.png',
    img9: '/assets/images/preview-img/img9@3x.png',
    img10: '/assets/images/preview-img/img10@3x.png',
    img11: '/assets/images/preview-img/img11@3x.png',
    img12: '/assets/images/preview-img/img12@3x.png',
    img13: '/assets/images/preview-img/img13@3x.png',
    img14: '/assets/images/preview-img/img14@3x.png',
    img15: '/assets/images/preview-img/img15@3x.png',
    img16: '/assets/images/preview-img/img16@3x.png',
  },
  threed: {
    img1: '/assets/images/3d/3d-1.png',
    img2: '/assets/images/3d/3d-2.png',
    img3: '/assets/images/3d/3d-3.png',
    img4: '/assets/images/3d/3d-4.png',
    img5: '/assets/images/3d/3d-5.png',
    img6: '/assets/images/3d/3d-6.png',
    img7: '/assets/images/3d/3d-7.png',
    img8: '/assets/images/3d/3d-8.png',
    img9: '/assets/images/3d/3d-9.png',
    img10: '/assets/images/3d/3d-10.png',
    img11: '/assets/images/3d/3d-11.png',
    img12: '/assets/images/3d/3d-12.png',
  },
  meleon: {
    img1: '/assets/images/meleon/meleon_photo01.jpg',
    img2: '/assets/images/meleon/meleon_photo02.jpg',
    img3: '/assets/images/meleon/meleon_photo03.jpg',
    img4: '/assets/images/meleon/meleon_photo04.jpg',
    img5: '/assets/images/meleon/meleon_photo05.jpg',
    img6: '/assets/images/meleon/meleon_photo06.jpg',
    img7: '/assets/images/meleon/meleon_photo07.jpg',
    img8: '/assets/images/meleon/meleon_photo08.jpg',
    img9: '/assets/images/meleon/meleon_photo09.jpg',
    img10: '/assets/images/meleon/meleon_photo010.jpg',
    img11: '/assets/images/meleon/meleon_photo011.jpg',
    img12: '/assets/images/meleon/meleon_photo012.jpg',
    img13: '/assets/images/meleon/meleon_photo013.jpg',
    img14: '/assets/images/meleon/meleon_photo014.jpg',
    img15: '/assets/images/meleon/meleon_photo015.jpg',
    img16: '/assets/images/meleon/meleon_photo016.jpg',
    img17: '/assets/images/meleon/meleon_photo017.jpg',
    img18: '/assets/images/meleon/meleon_photo018.jpg',
    img19: '/assets/images/meleon/meleon_photo019.jpg',
    img20: '/assets/images/meleon/meleon_photo020.jpg',
    img21: '/assets/images/meleon/meleon_photo021.jpg',
    img22: '/assets/images/meleon/meleon_photo022.jpg',
    img23: '/assets/images/meleon/meleon_photo023.jpg',
    img24: '/assets/images/meleon/meleon_photo024.jpg',
    img25: '/assets/images/meleon/meleon_photo025.jpg',
    img26: '/assets/images/meleon/meleon_photo026.jpg',
    img27: '/assets/images/meleon/meleon_photo027.jpg',
    img28: '/assets/images/meleon/meleon_photo028.jpg',
    img29: '/assets/images/meleon/meleon_photo029.jpg',
    img30: '/assets/images/meleon/meleon_photo030.jpg',
    img31: '/assets/images/meleon/meleon_photo031.jpg',
    img32: '/assets/images/meleon/meleon_photo032.jpg',
    img33: '/assets/images/meleon/meleon_photo033.jpg',
    img34: '/assets/images/meleon/meleon_photo034.jpg',
    img35: '/assets/images/meleon/meleon_photo035.jpg',
    img36: '/assets/images/meleon/meleon_photo036.jpg',
    img37: '/assets/images/meleon/meleon_photo037.jpg',
    img38: '/assets/images/meleon/meleon_photo038.jpg',
    img39: '/assets/images/meleon/meleon_photo039.jpg',
    img40: '/assets/images/meleon/meleon_photo040.jpg',
    img41: '/assets/images/meleon/meleon_photo041.jpg',
    img42: '/assets/images/meleon/meleon_photo042.jpg',
    img43: '/assets/images/meleon/meleon_photo043.jpg',
    img44: '/assets/images/meleon/meleon_photo044.jpg',
    img45: '/assets/images/meleon/meleon_photo045.jpg',
    img46: '/assets/images/meleon/meleon_photo046.jpg',
  },
  video: {
    video1: '/assets/video/sea.mp4',
    splash: '/assets/video/splash.mp4',
  },
  '3d': {
    car: '/assets/3d/car.fbx',
    studio: '/assets/3d/studio.obj',
  },
  bg: {
    music: '/assets/images/bg/music-bg.jpg',
    image: '/assets/images/bg/image-bg.jpg',
    video: '/assets/images/bg/video-bg.jpg',
  },
};
